<template>
    <div id="cumulative_income_chart" style="width: 745px; height: 346px; margin-left: 33px; float: left;">
        <div ref="chartRef" style="width: 100%; height: 100%;"></div>
    </div>
</template>

<script>
    /* eslint-disable no-new */
    /* global WdatePicker */
    import echarts from 'echarts'
    import {showTradeDateDialog} from '@/lib/wDatePicker.js'
    let chart = null

    export default {
        data () {
            return {
                detailContent: '',
                backtestContent: '',
                // 日期选择相关
                minDate: '',
                maxDate: '',
                // 范围选择按钮
                rangeButtons: [
                    { text: '全部', type: 'all', days: 0 },
                    { text: '一周', type: 'week', days: 7 },
                    { text: '一月', type: 'month', days: 30 },
                    { text: '一季', type: 'quarter', days: 90 },
                    { text: '半年', type: 'halfYear', days: 180 },
                    { text: '一年', type: 'year', days: 365 }
                ],
                currentRange: 'all'
            }
        },
        props: {
            profitdata: {
                type: [Array, Object],
                required: true
            },
            dayselect: {
                type: Array,
                required: true
            },
            HSData: {
                type: Array,
                required: true
            },
            defaultSelectedDay: {
                type: Array,
                default: function () {
                    return []
                }
            }
        },
        computed: {
            detailContentPoint () {
                return this.$buriedPoint.strategyDetails.profitChart.zoomSwitch
            },
            backtestContentPoint () {
                return this.$buriedPoint.strategyBacktest.profitChart.zoomSwitch
            }
        },
        methods: {
            showTradeDateDialog,
            _requestChartData: function () {
                this.updateChartData()
            },
            _debouce (func, wait, immediate) {
                var timeout
                var f = function () {
                    var context = this
                    var args = arguments
                    clearTimeout(timeout)
                    timeout = setTimeout(function () {
                        timeout = null
                        if (!immediate) func.apply(context, args)
                    }, wait)
                    if (immediate && !timeout) func.apply(context, args)
                }
                return f
            },
            changeDateVal: function (date) {
                return String(date).substring(0, 4) + '-' + String(date).substring(4, 6) + '-' + String(date).substring(6)
            },
            getTime: function (date) {
                var dateStr = this.changeDateVal(date)
                return (new Date(dateStr)).getTime()
            },
            getChartOptions: function (seriesData) {
                var allDates = []
                seriesData.forEach(function (series) {
                    series.data.forEach(function (item) {
                        if (allDates.indexOf(item[0]) === -1) {
                            allDates.push(item[0])
                        }
                    })
                })
                allDates.sort(function (a, b) {
                    return a - b
                })

                if (allDates.length > 0) {
                    this.minDate = this.changeDateVal(String(allDates[0]).substring(0, 8))
                    this.maxDate = this.changeDateVal(String(allDates[allDates.length - 1]).substring(0, 8))
                }

                // 将数据转换为百分比变化（compare: 'percent' 效果）
                // 同时保存原始数值用于 tooltip 显示
                seriesData.forEach(function (series) {
                    var firstValue = series.data.length > 0 ? series.data[0][1] : 0
                    series.originalData = series.data.map(function (item) {
                        return [item[0], item[1]]
                    })
                    series.data = series.data.map(function (item) {
                        // 计算相对于第一个点的百分比变化
                        var percentChange = 0
                        if (firstValue !== 0 && firstValue !== null && firstValue !== undefined) {
                            percentChange = ((item[1] - firstValue) / Math.abs(firstValue)) * 100
                        }
                        return [item[0], percentChange]
                    })
                })

                return {
                    legend: {
                        show: true,
                        align: 'left',
                        top: 0,
                        left: 0,
                        data: seriesData.map(function (s) { return s.name }),
                        icon: 'roundRect',
                        itemWidth: 20,
                        itemHeight: 3
                    },
                    tooltip: {
                        trigger: 'axis',
                        backgroundColor: 'rgba(255, 255, 255, 0.95)',
                        borderColor: '#ddd',
                        borderWidth: 1,
                        padding: [10, 15],
                        textStyle: {
                            color: '#333',
                            fontSize: 13
                        },
                        formatter: function (params) {
                            if (!params || params.length === 0) return ''

                            const dateObj = new Date(params[0].axisValue)
                            var date = dateObj.getFullYear() + '-' + (dateObj.getMonth() + 1) + '-' + dateObj.getDate()
                            var html = '<div style="font-size:13px;line-height:18px;margin-bottom:5px;">' + date + '</div>'
                            params.forEach(function (item) {
                                var color = item.color
                                var percentValue = item.value[1] // 百分比变化值
                                var seriesName = item.seriesName

                                // 百分比变化颜色
                                var changeColor = percentValue >= 0 ? 'red' : 'green'

                                html += '<div style="line-height:18px;">'
                                html += '<span style="display:inline-block;width:10px;height:10px;background:' + color + ';margin-right:5px;border-radius:2px;"></span>'
                                html += seriesName + '：'
                                html += '(<span style="color:' + changeColor + '">' + (percentValue !== null ? percentValue.toFixed(2) : '--') + '%</span>)'
                                html += '</div>'
                            })

                            return html
                        }
                    },
                    grid: {
                        left: 60,
                        right: 60,
                        top: 50,
                        bottom: 80
                    },
                    xAxis: {
                        type: 'time',
                        boundaryGap: false,
                        axisLine: {
                            lineStyle: {
                                color: '#e0e0e0'
                            }
                        },
                        axisTick: {
                            show: false
                        },
                        axisLabel: {
                            color: '#666',
                            fontSize: 11,
                            formatter: function (value) {
                                var date = new Date(value)
                                var month = (date.getMonth() + 1).toString().padStart(2, '0')
                                var day = date.getDate().toString().padStart(2, '0')
                                return month + '-' + day
                            }
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: '#f0f0f0',
                                type: 'dashed'
                            }
                        }
                    },
                    yAxis: {
                        type: 'value',
                        position: 'right',
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: '#e0e0e0'
                            }
                        },
                        axisTick: {
                            show: false
                        },
                        axisLabel: {
                            color: '#666',
                            fontSize: 11,
                            formatter: function (value) {
                                return value.toFixed(2) + '%'
                            }
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: '#f0f0f0',
                                type: 'dashed'
                            }
                        },
                        scale: true
                    },
                    dataZoom: [
                        {
                            type: 'slider',
                            show: true,
                            xAxisIndex: 0,
                            start: 0,
                            end: 100,
                            height: 20,
                            bottom: 10,
                            left: 60,
                            right: 60,
                            borderColor: 'transparent',
                            backgroundColor: '#f9f9f9',
                            fillerColor: 'rgba(63, 82, 180, 0.2)',
                            handleSize: '100%',
                            handleStyle: {
                                color: '#3f52b4',
                                shadowBlur: 3,
                                shadowColor: 'rgba(0, 0, 0, 0.3)',
                                shadowOffsetX: 2,
                                shadowOffsetY: 2
                            },
                            textStyle: {
                                color: '#8a8b8c'
                            },
                            dataBackground: {
                                lineStyle: {
                                    color: '#ddd'
                                },
                                areaStyle: {
                                    color: '#eee'
                                }
                            }
                        },
                        {
                            type: 'inside',
                            xAxisIndex: 0,
                            start: 0,
                            end: 100
                        }
                    ],
                    series: seriesData
                }
            },
            updateChartData: function () {
                var key
                var index
                var num
                var dateData = []
                var visibled = false
                var series = []

                // 添加沪深300数据
                var hsdata = []
                for (num in this.HSData) {
                    var time = this.HSData[num]['timestamp']
                    var timeInt = this.getTime(time)
                    var data = this.HSData[num]['value']
                    hsdata.push([timeInt, data])
                    dateData.push(this.changeDateVal(time))
                }
                series.push({
                    data: hsdata,
                    name: '沪深300',
                    type: 'line',
                    symbol: 'none',
                    lineStyle: {
                        width: 1.5,
                        color: '#999'
                    }
                })

                // 添加策略数据
                for (key in this.profitdata) {
                    var strategyData = []
                    var ItemDaySaleStrategy = Number(this.profitdata[key]['daySaleStrategy'])
                    if (this.defaultSelectedDay.indexOf(ItemDaySaleStrategy) >= 0) {
                        visibled = true
                    } else {
                        visibled = false
                    }
                    var backtestData = this.profitdata[key].everydayIncome
                    for (index in backtestData) {
                        var date = backtestData[index][0]
                        var dateInt = this.getTime(date)
                        var algoProfit = backtestData[index][1]
                        strategyData.push([dateInt, algoProfit])
                        if (dateData.indexOf(this.changeDateVal(date)) === -1) {
                            dateData.push(this.changeDateVal(date))
                        }
                    }
                    series.push({
                        data: strategyData,
                        name: this.dayselect[key] + '天',
                        type: 'line',
                        symbol: 'none',
                        lineStyle: {
                            width: 1.5
                        },
                        visible: visibled
                    })
                }

                if (chart !== null) {
                    this.hasChart = true
                    chart.dispose()
                    chart = null
                }

                chart = echarts.init(this.$refs.chartRef)
                chart.setOption(this.getChartOptions(series))

                var self = this
                // 绑定日期选择器事件
                this.$nextTick(function () {
                    self.bindDatePickerEvents()
                })

                chart.on('datazoom', function () {
                    function a () {
                        window.TA.log(self.detailContentPoint)
                    }
                    function b () {
                        window.TA.log(self.backtestContentPoint)
                    }
                    if (self.detailContent) {
                        self._debouce(a, 500, true)()
                    } else {
                        self._debouce(b, 500, true)()
                    }
                })

                window.addEventListener('resize', function () {
                    if (chart) {
                        chart.resize()
                    }
                })
            },
            bindDatePickerEvents: function () {
                var self = this
                var chartDom = this.$refs.chartRef
                if (!chartDom) return

                // 查找所有dataZoom的输入框
                var inputs = chartDom.querySelectorAll('.ec-dataZoom-input')
                for (var i = 0; i < inputs.length; i++) {
                    inputs[i].addEventListener('focus', function () {
                        new WdatePicker({
                            el: this,
                            maxDate: self.maxDate,
                            minDate: self.minDate,
                            isShowClear: false,
                            readOnly: true,
                            onpicked: function () {
                                this.onchange()
                                this.onblur()
                                this.blur()
                            }
                        })
                    })
                }
            },
            handleRangeClick: function (type, days) {
                this.currentRange = type
                if (!chart) return

                var allDates = []
                chart.getOption().series[0].data.forEach(function (item) {
                    allDates.push(item[0])
                })

                if (days === 0 || allDates.length <= 1) {
                    // 全部
                    chart.dispatchAction({
                        type: 'dataZoom',
                        start: 0,
                        end: 100
                    })
                } else {
                    // 计算开始和结束位置
                    var endTime = allDates[allDates.length - 1]
                    var startTime = endTime - days * 24 * 3600 * 1000

                    // 找到最近的开始索引
                    var startIndex = 0
                    for (var i = 0; i < allDates.length; i++) {
                        if (allDates[i] >= startTime) {
                            startIndex = i
                            break
                        }
                    }

                    var startPercent = (startIndex / allDates.length) * 100
                    chart.dispatchAction({
                        type: 'dataZoom',
                        start: startPercent,
                        end: 100
                    })
                }
            }
        },
        mounted () {
            this._requestChartData()
            this.detailContent = document.getElementsByClassName('strategydetailmain')[0]
            this.backtestContent = document.getElementsByClassName('strategybacktestmain')[0]
        },
        watch: {
            profitdata () {
                this.updateChartData()
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @import '../../scss/strategybacktest/cumulative_income.scss';
</style>


// WEBPACK FOOTER //
// src/components/strategybacktest/cumulativeIncomeChart.vue